module.exports = __webpack_public_path__ + "static/img/logo21.2bd7462b.png";